"use strict"

export class Grid {
    
    constructor(cfg) {
        this.grid=initDatagrid2.makeNew(cfg);
        if (this.grid.isNull) { throw "Null instance gridu"; }
    }
    
    render(box) {
        box.inner.innerHTML='';
        box.inner.appendChild(this.grid.element);
        box.closeButton.onclick=()=>{box.hide()};
        box.cfg.onclose=()=>this.grid.boxClose({box:box});
    }
    
}